/* ============================================================
   Cloud Store · Editorial JS (Vague 4)
   Blog tags filter, article share buttons, product card insert,
   contact FAQ.
   ============================================================ */
(function () {
  if (window.__csEditorialInit) return;
  window.__csEditorialInit = true;

  // ---------- Article share buttons ----------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cs-share]');
    if (!btn) return;
    const action = btn.dataset.csShare;
    if (action === 'copy') {
      e.preventDefault();
      navigator.clipboard.writeText(window.location.href).then(() => {
        showToast('Lien copié 🔗');
      }).catch(() => {
        showToast('Impossible de copier', true);
      });
    }
  });

  // ---------- Article product-card insertion ----------
  function insertProductCard() {
    const card = document.querySelector('[data-cs-article-product]');
    const body = document.querySelector('[data-cs-article-body]');
    if (!card || !body) return;
    const paragraphs = body.querySelectorAll('p');
    if (paragraphs.length < 4) return; // too short, leave at end (Liquid fallback)
    const targetIdx = Math.floor(paragraphs.length * 0.65);
    const target = paragraphs[targetIdx];
    if (target && target.parentNode) {
      target.parentNode.insertBefore(card, target.nextSibling);
      card.style.display = '';
    }
  }

  // ---------- Contact "open Mimi" trigger ----------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cs-contact-mimi]');
    if (!btn) return;
    e.preventDefault();
    const mimiTrigger = document.querySelector('[data-cs-mimi-trigger]');
    if (mimiTrigger) mimiTrigger.click();
  });

  // ---------- Toast helper ----------
  function showToast(msg, isError = false) {
    if (window.__csShowToast) {
      window.__csShowToast(msg, isError);
      return;
    }
    const t = document.createElement('div');
    t.className = 'cs-toast' + (isError ? ' warning' : '');
    t.textContent = msg;
    Object.assign(t.style, {
      position: 'fixed', bottom: '24px', left: '50%',
      transform: 'translateX(-50%)',
      background: isError ? '#c44a4a' : 'var(--cs-bordeaux, #5E2F4D)',
      color: 'white', padding: '14px 20px', borderRadius: '16px',
      fontSize: '14px', zIndex: 300,
      boxShadow: '0 8px 24px rgba(33,29,44,0.2)',
    });
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 3500);
  }

  // ---------- Article likes (Cloudflare Worker backend) ----------
  const LIKE_STORAGE_KEY = 'cs:liked-articles';
  function getLikedSet() {
    try { return new Set(JSON.parse(localStorage.getItem(LIKE_STORAGE_KEY) || '[]')); }
    catch { return new Set(); }
  }
  function saveLikedSet(set) {
    try { localStorage.setItem(LIKE_STORAGE_KEY, JSON.stringify([...set])); } catch {}
  }

  async function initLikeWidget(el) {
    const id = el.dataset.csLikeId;
    const endpoint = (el.dataset.csLikeEndpoint || '').replace(/\/$/, '');
    if (!id || !endpoint) return;
    const countEl = el.querySelector('[data-cs-like-count]');
    const titleEl = el.querySelector('[data-cs-like-title]');
    const btn = el.querySelector('button');
    const liked = getLikedSet();

    if (liked.has(id)) {
      btn.setAttribute('aria-pressed', 'true');
      el.classList.add('is-liked');
      if (titleEl) titleEl.textContent = 'Merci pour ton coeur !';
    }

    try {
      const r = await fetch(`${endpoint}/likes?ids=${encodeURIComponent(id)}`, { credentials: 'omit' });
      if (r.ok) {
        const data = await r.json();
        countEl.textContent = data[id] != null ? data[id] : 0;
      } else {
        countEl.textContent = '0';
      }
    } catch {
      countEl.textContent = '0';
    }

    btn.addEventListener('click', async () => {
      if (btn.disabled) return;
      btn.disabled = true;

      const wasLiked = liked.has(id);
      const newLiked = !wasLiked;
      const prevCount = parseInt(countEl.textContent, 10) || 0;
      const optimistic = Math.max(0, prevCount + (newLiked ? 1 : -1));

      el.classList.toggle('is-liked', newLiked);
      el.classList.add('is-pulsing');
      btn.setAttribute('aria-pressed', String(newLiked));
      countEl.textContent = optimistic;
      if (titleEl) titleEl.textContent = newLiked ? 'Merci pour ton coeur !' : 'Cet article t’a plu ?';
      if (newLiked) liked.add(id); else liked.delete(id);
      saveLikedSet(liked);
      setTimeout(() => el.classList.remove('is-pulsing'), 500);

      try {
        const r = await fetch(`${endpoint}/likes/${encodeURIComponent(id)}/toggle`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ liked: newLiked }),
          credentials: 'omit',
        });
        if (r.status === 429) {
          showToast('Doucement, merci 🙂', true);
          throw new Error('rate_limited');
        }
        if (!r.ok) throw new Error('http_' + r.status);
        const data = await r.json();
        if (typeof data.count === 'number') countEl.textContent = data.count;
      } catch {
        el.classList.toggle('is-liked', wasLiked);
        btn.setAttribute('aria-pressed', String(wasLiked));
        countEl.textContent = prevCount;
        if (titleEl) titleEl.textContent = wasLiked ? 'Merci pour ton coeur !' : 'Cet article t’a plu ?';
        if (wasLiked) liked.add(id); else liked.delete(id);
        saveLikedSet(liked);
      } finally {
        btn.disabled = false;
      }
    });
  }

  // ---------- Init on load ----------
  document.addEventListener('DOMContentLoaded', () => {
    insertProductCard();
    document.querySelectorAll('[data-cs-like]').forEach(initLikeWidget);
  });
})();
